import { render } from "./PartnerCompanies.vue?vue&type=template&id=109f70f1"
import script from "./PartnerCompanies.vue?vue&type=script&lang=js"
export * from "./PartnerCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__